// @mui
import PropTypes from 'prop-types';
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
import '../../../layouts/dashboard/header/sty.css'
import CircularProgress from '@mui/material/CircularProgress';
import {useState, useEffect} from 'react';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';
// components
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const StyledIcon = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
}));

// ----------------------------------------------------------------------

InnerAppAnalytics.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  title1: PropTypes.string,
  title2: PropTypes.string,
  total: PropTypes.number,
  total1: PropTypes.number,
  total2: PropTypes.number,
  sx: PropTypes.object,
};

export default function InnerAppAnalytics({ title1, total1, title2, total2,title, total, icon, bg_color,underline_title, color = 'primary', sx, ...other }) {
  const [isPending, setIsPending] = useState(false);
  useEffect(() => {
    if (total=== '') {
      setIsPending(true)
    }else{
      setIsPending(false)
    }
  }, [total]);

  return (
    <Card
      sx={{
        py: 2,
        boxShadow: 0,
        textAlign: 'center',
        color: (theme) => theme.palette[color].darker,
        // bgcolor: bg_color, //(theme) => theme.palette[color].lighter,
        ...sx,
      }}
      {...other}
      className={`${bg_color}`}
    >
      <div className="row texLeft"> 
        <div className={`col-10 texLeft text-white m-0 p-0 pl-2`}>
          <Typography variant="subtitle2" sx={{ opacity: 2 }}>
            <div className={`title subtitle2`}>
             <strong> {title} </strong>
            </div>
          </Typography>
          <div className={`${underline_title}`}></div>
          <Typography variant="p">
            {isPending && <CircularProgress style={{ color: '#3c8dbc' }} size="1rem" />}
            {!isPending && <span className="josefin-sans-header size"> {total ? total.toLocaleString() : 0}</span>}
          </Typography>
          
        </div>
        <div className="col-2 p-0">
          <img style={{ width:'80%', height:"70px"}} src={`/assets/icons/${icon}`} alt="icon"/>
        </div>
      </div> 
      
    </Card>
  );
}
